import httpClient from '@src/services/http.service'
import axios from 'axios'

import PhoneIcon from '@assets/icons/e-phone.svg'
import CardIcon from '@assets/icons/e-card.svg'
import router from '@router'

const icons = [PhoneIcon, CardIcon]

export const state = {
  pageData: [],
  passTypeCards: [],
  isFieldsValid: false,
  cards: [],
  order: {},
  orderPdfLink: '',
  loader: false,
  cardsLoader: true,
  data: {
    selectedType: 'coolpass',
    subscribe: true,
    cards: [],
    userData: {
      arrivalDay: new Date(),
      name: '',
      email: '',
      country: '',
    },
  },
}

export const actions = {
  init: ({ commit }) => {
    httpClient
      .get('pages/60bad8c6715b60a32b4d00cb')
      .then((response) => {
        commit('SET_PAGE_DATA', response.data)
      })
      .catch((error) => {
        commit('SET_ERROR', error.message)
      })

    const passTypeCards = [
      {
        id: 1,
        text: 'ESHOP_qr_type_text',
        value: 'coolpass',
        icon: icons[0],
      },
      {
        id: 2,
        text: 'ESHOP_card_type_text',
        value: 'card',
        icon: icons[1],
      },
    ]
    commit('SET_PASS_TYPE', passTypeCards)
  },

  setCardsCalculatorData: ({ commit, rootGetters }) => {
    const cardsData = rootGetters['cards/cards'].map((card, i) => {
      return {
        id: card.id,
        name: card.name,
        adultCard: card.products[0],
        studentCard: card.products[1],
        adultCardVirtual: card.products[2],
        studentCardVirtual: card.products[3],
        adultCardCount: 0,
        studentCardCount: 0,
        adultCardSum: 0,
        studentCardSum: 0,
      }
    })
    commit('SET_CARDS', cardsData)
    commit('SET_LOADING_CARDS', false)
  },

  sendCred: (_, data) => {
    const getEshopId = () => {
      const url = new URLSearchParams(window.location.search)
      let eshopId = url.get('eshopId')
      if (eshopId == null) {
        eshopId = '77a85a2a-6b84-4d79-b856-dfafc14340a0'
      }
      return eshopId
    }

    const orderData = { ...data, eshop_id: getEshopId() }
    axios
      .post(
        `${process.env.VUE_APP_ESHOP_BASE_URL}/create-checkout-session`,
        orderData,
        {
          headers: {
            Authorization: process.env.VUE_APP_AUTH_HEADRES,
          },
        }
      )
      .then((response) => {
        const { sessionId } = response.data
        const stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY)

        stripe.redirectToCheckout({ sessionId })
      })
      .catch((error) => {
        console.log(error.message)
      })
  },

  sendCredMobile: (_, sessionId) => {
    const stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY)

    stripe.redirectToCheckout({ sessionId })
  },

  fetchOrder: async ({ commit }, queryData) => {
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
    const getEshopId = () => {
      const url = new URLSearchParams(window.location.search)
      let eshopId = url.get('eshopId')
      if (eshopId == null) {
        eshopId = '77a85a2a-6b84-4d79-b856-dfafc14340a0'
      }
      return eshopId
    }

    const gQuery = async () => {
      commit('SET_LOADING', true)
      try {
        if (queryData.type === 'voucher') {
          const response = await axios.get(
            `${
              process.env.VUE_APP_ESHOP_BASE_URL
            }/get-order-by-voucher?voucherNumber=${
              queryData.value
            }&eshopId=${getEshopId()}`,
            {
              headers: {
                Authorization: process.env.VUE_APP_AUTH_HEADRES,
              },
            }
          )

          return response.data
        }

        const response = await axios.get(
          `${process.env.VUE_APP_ESHOP_BASE_URL}/get-order-details?sessionId=${
            queryData.value
          }&eshopId=${getEshopId()}`,
          {
            headers: {
              Authorization: process.env.VUE_APP_AUTH_HEADRES,
            },
          }
        )

        return response.data
      } catch (err) {
        commit('SET_LOADING', false)
        return null
      }
    }

    let counter = 0
    let data = await gQuery()

    if (!data) {
      return data
    }

    if (data.order_status > 4) {
      router
        .push({
          name: 'eshop',
          query: { session_id: 'null', type: 'payment_failed' },
        })
        .catch(() => {})
      return data
    }

    while (data.order_status !== 4) {
      counter++
      if (counter === 10) {
        return
      }
      await wait(2000)
      data = await gQuery()
    }
    commit('SET_ORDER', data)
    const voucherNumber = data.order_info.voucher_number
    const pdfLink = `${
      process.env.VUE_APP_ESHOP_BASE_URL
    }/get-voucher?voucherNumber=${voucherNumber}&eshopId=${getEshopId()}`
    commit('SET_PDF', pdfLink)
    commit('SET_LOADING', false)
  },
  editOrder: () => {
    const getEshopId = () => {
      const url = new URLSearchParams(window.location.search)
      let eshopId = url.get('eshopId')
      if (eshopId == null) {
        eshopId = '77a85a2a-6b84-4d79-b856-dfafc14340a0'
      }
      return eshopId
    }
    const order = state.order.order_info
    const changedOrderData = {
      EShopId: getEshopId(),
      VoucherNumber: order.voucher_number,
      PickupDate: order.pickup_date,
      CustomerName: order.customer_name,
    }

    axios
      .post(
        `${process.env.VUE_APP_ESHOP_BASE_URL}/change-order`,
        changedOrderData,
        {
          headers: {
            Authorization: process.env.VUE_APP_AUTH_HEADRES,
          },
        }
      )
      .catch((error) => {
        console.log(error.message)
      })
  },

  cancelOrder: () => {
    const getEshopId = () => {
      const url = new URLSearchParams(window.location.search)
      let eshopId = url.get('eshopId')
      if (eshopId == null) {
        eshopId = '77a85a2a-6b84-4d79-b856-dfafc14340a0'
      }
      return eshopId
    }
    const order = state.order.order_info
    const changedOrderData = {
      EShopId: getEshopId(),
      VoucherNumber: order.voucher_number,
    }

    axios
      .post(
        `${process.env.VUE_APP_ESHOP_BASE_URL}/cancel-order`,
        changedOrderData,
        {
          headers: {
            Authorization: process.env.VUE_APP_AUTH_HEADRES,
          },
        }
      )
      .catch((error) => {
        console.log(error.message)
      })
  },
}

export const mutations = {
  SET_PAGE_DATA: (state, pageData) => {
    state.pageData = pageData
  },
  SET_PASS_TYPE: (state, passTypeCards) => {
    state.passTypeCards = passTypeCards
  },
  SET_ERROR: (state, error) => {
    state.error = error
  },
  SET_CARDS: (state, cards) => {
    state.cards = cards
  },
  SET_ORDER: (state, order) => {
    state.order = order
  },
  SET_PDF: (state, pdfLink) => {
    state.orderPdfLink = pdfLink
  },
  SET_LOADING: (state, value) => {
    state.loader = value
  },
  SET_LOADING_CARDS: (state, value) => {
    state.cardsLoader = value
  },
  INCREMENT_CARD_COUNT: (state, { cardId, cardType, cardTypeId }) => {
    const card = state.cards.find((card) => card.id === cardId)
    const userCard = state.data.cards.find((card) => card.id === cardTypeId)

    if (cardType === 'adult') {
      card.adultCardCount++
      card.adultCardSum = card.adultCardCount * card.adultCard.price
    } else if (cardType === 'child') {
      card.studentCardCount++
      card.studentCardSum = card.studentCardCount * card.studentCard.price
    }

    if (userCard) {
      userCard.count++
    } else {
      state.data.cards.push({
        id: cardTypeId,
        count: 1,
      })
    }
  },
  DECREMENT_CARD_COUNT: (state, { cardId, cardType, cardTypeId }) => {
    const card = state.cards.find((card) => card.id === cardId)
    const userCard = state.data.cards.find((card) => card.id === cardTypeId)

    if (cardType === 'adult') {
      if (card.adultCardCount > 0) {
        card.adultCardCount--
        card.adultCardSum = card.adultCardCount * card.adultCard.price
      }
    } else if (cardType === 'child') {
      if (card.studentCardCount > 0) {
        card.studentCardCount--
        card.studentCardSum = card.studentCardCount * card.studentCard.price
      }
    }

    if (userCard && userCard.count > 1) {
      userCard.count--
    } else {
      state.data.cards = state.data.cards.filter(
        (card) => card.id !== cardTypeId
      )
    }
  },
  DELETE_CARD: (state, { cardId, cardType, cardTypeId }) => {
    const card = state.cards.find((card) => card.id === cardId)

    if (cardType === 'adult') {
      card.adultCardCount = 0
      card.adultCardSum = 0
    } else if (cardType === 'child') {
      card.studentCardCount = 0
      card.studentCardSum = 0
    }

    state.data.cards = state.data.cards.filter((card) => card.id !== cardTypeId)
  },
  changePassType: (state, type) => {
    state.data.selectedType = type
  },
  changeSubscribe: (state) => {
    state.data.subscribe = !state.data.subscribe
  },
  changeValid: (state, value) => {
    state.isFieldsValid = value
  },
  updateUserData: (state, data) => {
    Object.assign(state.data.userData, data)
  },
  updateOrderData: (state, data) => {
    Object.assign(state.order.order_info, data)
  },
}

export const getters = {
  pageData: (state) => state.pageData,
  passTypeCards: (state) => state.passTypeCards,
  subscribe: (state) => state.data.subscribe,
  selectedType: (state) => state.data.selectedType,
  cards: (state) => state.cards,
  userData: (state) => state.data.userData,
  userCards: (state) => state.data.cards,
  orderData: (state) => state.order,
  pdfLink: (state) => state.orderPdfLink,
  loader: (state) => state.loader,
  cardsLoader: (state) => state.cardsLoader,
  isFieldsValid: (state) => state.isFieldsValid,
  pageDataCurrency: (state) => state.pageData,
}
